import { render, staticRenderFns } from "./Usages.vue?vue&type=template&id=9249c9c4&"
import script from "./Usages.vue?vue&type=script&lang=js&"
export * from "./Usages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports